import React from "react";
import Control from "react-leaflet-control";
import "./LayerPicker.scss";

/*
 * This component is a wrapper for the layer picker that controls which layers on the map is visible
 */

const LayerPicker = (props) => {
  return (
    <Control
      style={props.style}
      className="layerPickerContainer"
      position="topright"
    >
      {props.children}
    </Control>
  );
};

export default LayerPicker;
